import App from "./App.svelte"

let appContainer = document?.getElementById("appContainer")

const hydrate = true //import.meta?.env?.MODE !== "development"
console.log("Features: ", { hydrate })
const app = new App({
    target: appContainer,
    props: {},
    hydrate,
})

export default app
